import React, { useContext, useEffect, useState } from "react";
import { Grid, TextField, Typography, Button, IconButton, DialogTitle, DialogContent, Fade, CircularProgress, Checkbox, FormControlLabel, Link } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Stack } from "@mui/material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import LoginFormYahoo from "./LoginFormYahoo";
import { WidgetContext } from "src/contexts/WidgetContext";
import { isAndroid, isIOS } from "../../utils/platformUtils";
import LoginFormEspn from "./LoginFormEspn";
import { useSafeAccessAuth0Token } from "src/hooks/useSafeAccessAuth0Token";
import { sendEspnCode } from "src/api/sendEspnCode";
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import LoginFormText from "./LoginFormText";

function LoginForm({
  onClose,
  platformSelected,
  handlePlatformLoginClick,
  loginError,
  setLoginError,
  setTeamsdata,
  isChangingPlatform,
  setIsChangingPlatform,
  setLoggingInTo,
  setSelectedTeamInfo,
  setSelectedPartner,
  setLeagueIdPlatform,
  handleLoginCloseYahoo,
}) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [userpassword, setPassword] = useState("");
  const [error, setError] = useState("");
  const [yahooCode, setYahooCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);

  const { leaguePlatforms, aiSettings } = useContext(WidgetContext);

  const currentPlatform = leaguePlatforms.find((p) => p.isSelected)?.id;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDrawerOpen(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Function to fetch data from backend based on params in Sleeper
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!isAuthorized) {
      return;
    }
    setIsLoading(true);
    try {
      await handlePlatformLoginClick(platformSelected.id, username, userpassword);

      // onClose();
    } catch (error) {
      console.log("Login failed:", error);
      setError(error.message || "Failed to login");
      // setIsLoading(false); // Hide the loader when there is an error
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    // setIsChangingPlatform(true);

    setIsDrawerOpen(false);

    const timer = setTimeout(() => {
      onClose();
      setLoginError("");
      // setIsChangingPlatform(false);
    }, 500);
    return () => clearTimeout(timer);
  };

  const handleCloseYahoo = () => {
    // setIsChangingPlatform(true);
    //if the platform is yahoo_auth and there is no yahooCode, we need to clear the teamsdata to avoid showing the old team data
    if (platformSelected.credentials_type === "yahoo_auth" && !yahooCode && currentPlatform === "Yahoo") {
      const storedToken = localStorage.getItem("yahoo_token");
      const storedExpiration = localStorage.getItem("yahoo_token_expiration");
      let isStoredTokenCurrentlyValid = false;

      // Check if the stored token is currently valid
      if (storedToken && storedExpiration) {
        // Check if the stored token is currently valid
        const expirationTimeMs = parseInt(storedExpiration, 10);
        const currentTimeMs = Date.now();

        console.log("🕒 Token validation check:", {
          storedToken: storedToken ? `${storedToken.substring(0, 10)}...` : null,
          expirationTime: new Date(expirationTimeMs).toLocaleString(),
          currentTime: new Date(currentTimeMs).toLocaleString(),
          timeUntilExpiration: `${Math.floor((expirationTimeMs - currentTimeMs) / 1000 / 60)} minutes`,
          isValid: !isNaN(expirationTimeMs) && currentTimeMs < expirationTimeMs,
        });
        // If the token is valid, set the flag to true
        if (!isNaN(expirationTimeMs) && currentTimeMs < expirationTimeMs) {
          isStoredTokenCurrentlyValid = true;
          console.log("✅ Token is currently valid");
        } else {
          console.log("❌ Token is expired or invalid");
        }
      }

      // If there is no yahooCode from this interaction AND there is no valid token in localStorage, clean the data.
      if (!isStoredTokenCurrentlyValid) {
        // setTeamsdata([]);
        setSelectedTeamInfo(null);
        setSelectedPartner("");
        setLeagueIdPlatform("");
      }
    }

    setIsDrawerOpen(false);

    const timer = setTimeout(() => {
      onClose();
      setLoginError("");
      // setIsChangingPlatform(false);
    }, 500);
    return () => clearTimeout(timer);
  };

  const handleYahooSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      //here we send the yahooCode instead of username and password to homepage.tsx
      await handlePlatformLoginClick(platformSelected.id, yahooCode, null);
    } catch (error) {
      console.log("Failed to login with yahoo", error);
      setError("Failed to login with yahoo");
      // setIsLoading(false); // Hide the loader when there is an error
    } finally {
      setIsLoading(false);
    }
  };

  const handleEspnSubmit = async (email: string, sessionId: string, passcode: string) => {
    setIsLoading(true);
    try {
      await handlePlatformLoginClick(platformSelected.id, email, { sessionId, passcode });
    } catch (error) {
      console.log("Failed to login with ESPN", error);
      setError(error.message || "Failed to login with ESPN");
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <SwipeableDrawer
      anchor="bottom"
      open={isDrawerOpen}
      onOpen={() => setIsDrawerOpen(true)}
      // onClose={platformSelected.credentials_type === "yahoo_auth" ? handleCloseYahoo : handleClose}
      onClose={handleClose}
      // hideBackdrop={true}
      // sx={{
      //   pointerEvents: "none", // Add this - makes the entire drawer container non-interactive
      // }}
      ModalProps={{
        sx: {
          zIndex: 1450,
        },
      }}
      PaperProps={{
        sx: {
          width: {
            xs: "100%",
            sm: "720px",
            md: "720px",
            lg: "720px",
          },
          margin: {
            xs: "0",
            sm: "0 auto",
            md: "0 auto",
            lg: "0 auto",
          },
          // height: "100%",
          // height: "calc(100svh - env(safe-area-inset-top) - 56px)",
          height: isIOS || isAndroid
            ? (aiSettings.quan ? "calc(100svh - env(safe-area-inset-top))" : "calc(100svh - env(safe-area-inset-top) - 56px)")
            : (!aiSettings.quan ? "calc(100vh - 56px)" : "100%"),
          border: `0.5px solid ${PureLightThemeCaaS.colors.alpha.white[70]}`,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          bgcolor: "#EDEDED",
        },
      }}
    >
      <Fade in={isDrawerOpen}>
        <Box sx={{ width: "100%" }}>
          <DialogTitle sx={{ bgcolor: "#EDEDED", borderTopLeftRadius: 5, borderTopRightRadius: 5, pb: 2 }}>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                // ADD THIS LINE to respect the bottom safe area on all devices
                paddingBottom: isAndroid ? "max(env(safe-area-inset-bottom), 15px)" : "0px",
              }}
            >
              {/* CUANDO AGREGUEMOS IMAGENES DE LOGOS REALES DE NUEVO, ELIMINAR EL BOX Y DEJAR LAS IMGS */}
              <Box sx={{ visibility: "hidden" }}>
                {platformSelected.credentials_type === "yahoo_auth" ? null : (
                  <img
                    key={platformSelected.id}
                    src={platformSelected.img}
                    alt={`${platformSelected.name} logo`}
                    style={{
                      width: "50px",
                      aspectRatio: "3/2",
                      objectFit: "contain",
                      mixBlendMode: "normal",
                    }}
                  />
                )}
              </Box>
              <Typography variant="h4">
                {platformSelected.credentials_type === "yahoo_auth" || platformSelected.credentials_type === "espn_auth" ? "" : platformSelected.name}
              </Typography>
              <IconButton aria-label="close" onClick={handleLoginCloseYahoo || handleClose}>
                {/* <IconButton aria-label="close" onClick={platformSelected.credentials_type === "yahoo_auth" ? handleCloseYahoo : handleClose}> */}

                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>

          {/* if isLoading is true, show the loading spinner */}
          {isLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
              <CircularProgress size={60} sx={{ color: "#FF672D" }} />
            </Box>
          ) : (
            <DialogContent sx={{ bgcolor: "#EDEDED" }}>
              {platformSelected.credentials_type === "yahoo_auth" ? (
                <LoginFormYahoo
                  platformSelected={platformSelected}
                  loginError={loginError}
                  setLoginError={setLoginError}
                  yahooCode={yahooCode}
                  setYahooCode={setYahooCode}
                  handleYahooSubmit={handleYahooSubmit}
                  isAuthorized={isAuthorized}
                  setIsAuthorized={setIsAuthorized}
                  setLoggingInTo={setLoggingInTo}
                />
              ) : platformSelected.credentials_type === "espn_auth" ? (
                <LoginFormEspn
                  platformSelected={platformSelected}
                  loginError={loginError}
                  setLoginError={setLoginError}
                  isAuthorized={isAuthorized}
                  setIsAuthorized={setIsAuthorized}
                  handleEspnSubmit={handleEspnSubmit}
                />
              ) : (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={1} justifyContent="center" sx={{ padding: 0 }}>
                    <Typography sx={{ position: "absolute" }} variant="h4" color={PureLightThemeCaaS.colors.alpha.orange[100]} textAlign="center">
                      {loginError}
                    </Typography>
                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                      <Typography variant="h6" color={PureLightThemeCaaS.colors.alpha.black[100]} textAlign="center" pb={0.5} pt={2}>
                        {platformSelected.id === "Fantrax"
                          ? "CODE"
                          : platformSelected.id === "Flea_flicker"
                            ? "EMAIL"
                            : platformSelected.id === "FFPC"
                              ? "USERNAME OR EMAIL"
                              : "USERNAME"}
                        {/* USERNAME */}
                      </Typography>
                      <TextField
                        id={`username${platformSelected.id}`}
                        size="small"
                        sx={{
                          border: `2px solid ${PureLightThemeCaaS.colors.info.lighter}`,
                          width: "80%",
                          borderRadius: 1,
                          backgroundColor: PureLightThemeCaaS.colors.alpha.white[100],
                          "& .MuiInputBase-input": {
                            "-webkit-user-select": "text !important",
                            "user-select": "text !important",
                            "-webkit-touch-callout": "default",
                            touchAction: "manipulation",
                          },
                        }}
                        // inputMode="text" // Explicitly indicate that this is a text field
                        inputProps={{ style: { fontWeight: "bold" }, autoComplete: "off", autoCorrect: "off", spellCheck: false, autoCapitalize: "off" }}
                        onChange={(e) => setUsername(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            if (isAuthorized) {
                              handleSubmit(e);
                            }
                          }
                        }}
                      />
                    </Grid>
                    {platformSelected.credentials_type !== "username" && (
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        <Typography variant="h6" color={PureLightThemeCaaS.colors.alpha.black[100]} textAlign="center" pb={0.5}>
                          PASSWORD
                        </Typography>
                        <TextField
                          id={`password${platformSelected.id}`}
                          type="password"
                          size="small"
                          sx={{
                            border: `2px solid ${PureLightThemeCaaS.colors.info.lighter}`,
                            width: "80%",
                            borderRadius: 1,
                            backgroundColor: PureLightThemeCaaS.colors.alpha.white[100],
                            "& .MuiInputBase-input": {
                              "-webkit-user-select": "text !important",
                              "user-select": "text !important",
                              "-webkit-touch-callout": "default",
                              touchAction: "manipulation",
                            },
                          }}
                          inputProps={{
                            style: { fontWeight: "bold" },
                            autoComplete: "off",
                            autoCorrect: "off",
                            spellCheck: false,
                            autoCapitalize: "off",
                          }}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </Grid>
                    )}

                    {/* Box for authorization text and checkbox */}
                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                      <Box display="flex" alignItems="flex-start" sx={{ width: "80%", margin: "0 auto" }}>
                        <Checkbox
                          checked={isAuthorized}
                          onChange={(e) => setIsAuthorized(e.target.checked)}
                          sx={{
                            padding: "0",
                            pt: 0.2,
                            boxShadow: "none",
                            marginRight: 1,
                            "&.Mui-checked": {
                              color: PureLightThemeCaaS.colors.alpha.black[100],
                            },
                            "&:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                        />
                        <LoginFormText platformSelected={platformSelected.name} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sx={{ textAlign: "center", mt: 1 }}>
                      <Button
                        variant="contained"
                        size="large"
                        type="submit"
                        disabled={!isAuthorized}
                        sx={{
                          bgcolor: PureLightThemeCaaS.colors.alpha.orange[100],
                          width: "320px",
                          height: "52px",
                          p: 0,
                          "&.Mui-disabled": {
                            bgcolor: PureLightThemeCaaS.colors.alpha.gray[30],
                            color: PureLightThemeCaaS.colors.alpha.black[50],
                          },
                        }}
                      >
                        Connect
                      </Button>
                    </Grid>
                    {/* <Stack flexDirection="row" justifyContent="center" alignItems="center" gap={2} pt={1}>
                  <Typography variant="h6" sx={{ textDecoration: "underline" }} color={PureLightThemeCaaS.colors.alpha.orange[100]} textAlign="center">
                    Forgot Password?
                  </Typography>
                  <Typography variant="h6" sx={{ textDecoration: "underline" }} color={PureLightThemeCaaS.colors.alpha.orange[100]} textAlign="center">
                    Create Account
                  </Typography>
                </Stack> */}
                  </Grid>
                </form>
              )}
            </DialogContent>
          )}
        </Box>
      </Fade>
    </SwipeableDrawer>
  );
}

export default LoginForm;
